import * as React from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import SubCard from 'ui-component/cards/SubCard';
import {
    Grid,
} from '@mui/material';
import TitleService from 'title-service';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

export default function RedQuickCheckboxField(props: any) {
    let { value = [], enumOptions, onChange } = props;
    if (enumOptions) {
        return (<>
            {enumOptions.map((enumOp, groupIndex) => {
                return (
                    <Grid item xs={12} md={6} key={groupIndex}>
                        <SubCard title={TitleService(`${enumOp}`)}>
                            <Grid container spacing={2}>
                                {Object.entries(enumOp).map((entry, index: number) => {
                                    return (
                                        <Grid item
                                            xs={12}
                                            key={`${index}-`}
                                            sx={{ pt: { xs: 2, sm: '0 !important' } }}
                                        >
                                            <FormGroup>
                                                <FormControlLabel
                                                    control={<Checkbox checked={!!value.some(v => v === entry[1])}
                                                        onClick={(arg) => {
                                                            if (onChange) {
                                                                if (value.indexOf(entry[1]) === -1) {
                                                                    onChange([...value, entry[1]]);
                                                                }
                                                                else {
                                                                    onChange([...value.filter(x => x !== entry[1])]);
                                                                }
                                                            }
                                                        }}
                                                    />} label={entry} />
                                            </FormGroup>
                                        </Grid>
                                    )
                                })}
                            </Grid>
                        </SubCard>
                    </Grid>)
            })}
        </>)
    }
    return (<span />);
}